// package: enterprise
// file: apigateway/enterprise/order.proto

import * as apigateway_enterprise_order_pb from "../../apigateway/enterprise/order_pb";
export class OrderService {
  static serviceName = "enterprise.OrderService";
}
export namespace OrderService {
  export class GetHistories {
    static readonly methodName = "GetHistories";
    static readonly service = OrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_enterprise_order_pb.GetHistoriesRequest;
    static readonly responseType = apigateway_enterprise_order_pb.GetHistoriesReply;
  }
  export class GetBilling {
    static readonly methodName = "GetBilling";
    static readonly service = OrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_enterprise_order_pb.GetBillingRequest;
    static readonly responseType = apigateway_enterprise_order_pb.GetBillingReply;
  }
  export class GetCsvPath {
    static readonly methodName = "GetCsvPath";
    static readonly service = OrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_enterprise_order_pb.GetCsvPathRequest;
    static readonly responseType = apigateway_enterprise_order_pb.GetCsvPathReply;
  }
}
